import api from './api';

export const stockService = {
  // Stokları getir
  getStocks: async () => {
    try {
      const response = await api.get('/api/business/stock');
      return response.data;
    } catch (error) {
      console.error('Stoklar getirilirken hata:', error);
      throw error;
    }
  },

  // Yeni stok ekle
  createStock: async (stockData) => {
    try {
      const response = await api.post('/api/business/stock', stockData);
      return response.data;
    } catch (error) {
      console.error('Stok eklenirken hata:', error);
      throw error;
    }
  },

  // Stok güncelle
  updateStock: async (stockId, updateData) => {
    try {
      const response = await api.patch(`/api/business/stock/${stockId}`, updateData);
      return response.data;
    } catch (error) {
      console.error('Stok güncellenirken hata:', error);
      throw error;
    }
  },

  // Stok sil
  deleteStock: async (stockId) => {
    try {
      const response = await api.delete(`/api/business/stock/${stockId}`);
      return response.data;
    } catch (error) {
      console.error('Stok silinirken hata:', error);
      throw error;
    }
  }
}; 